export const getSubaccountFromLocalStorage = () => {
  return localStorage.getItem(`selected_subaccount_of_${  window.pageProps.uid}`);
}
export const setSubaccountToLocalStorage = (value) => {
  localStorage.setItem(`selected_subaccount_of_${  window.pageProps.uid}`, value);
}

export const dmpTypeMap = {
  CONFIRM_EFFECTIVE_LEADS: {
    name: '有效',
    color: '#6EDB37',
  },
  CONFIRM_POTENTIAL_CUSTOMER: {
    name: '潜在',
    color: '#FFAC40',
  },
  VISIT_STORE: {
    name: '到店',
    color: '#4080FF',
  },
  PURCHASE: {
    name: '成单',
    color: '#8E84FD',
  },
  INEFFECTIVE_LEADS: {
    name: '无效',
    color: '#626366',
  },
  'app-注册': {
    name: 'App-注册',
    color: '#002266',
  },
  '预约': {
    name: '预约',
    color: '#804800',
  },
  '加企业微信客服': {
    name: '加企业微信客服',
    color: '#226600',
  },
  '网页咨询': {
    name: '网页咨询',
    color: '#2624B5',
  },
  '电话咨询': {
    name: '电话咨询',
    color: '#660800',
  },
  '下单': {
    name: '下单',
    color: '#615ADB',
  },
  '到店': {
    name: '到店',
    color: '#296BEF',
  },
  '体验': {
    name: '体验',
    color: '#FFAC40',
  },
  '确认有效线索': {
    name: '确认有效线索',
    color: '#5AC724',
  },
  '确认潜在客户': {
    name: '确认潜在客户',
    color: '#FA8E00',
  },
  '购买': {
    name: '购买',
    color: '#908AF0',
  },
  '无效': {
    name: '无效',
    color: '#939599',
  },
  '用户意向表单': {
    name: '用户意向表单',
    color: '#80AAFF',
  },
  '添加个人微信': {
    name: '添加个人微信',
    color: '#FFADA6',
  },
  '咨询留资': {
    name: '咨询留资',
    color: '#0941B3',
  },
  '激活': {
    name: '激活',
    color: '#FFD8A6',
  },
  '排程': {
    name: '排程',
    color: '#2F8C00',
  },
  '次日留存': {
    name: '次日留存',
    color: '#F28100',
  },
  '活动推广-加关注': {
    name: '活动推广-加关注',
    color: '#8C0C00',
  },
  '企微开口': {
    name: '企微开口',
    color: '#D97B00',
  },
  '网页-注册': {
    name: '网页-注册',
    color: '#A65E00',
  }
};
